import axios from 'axios';

const API = `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/steam-bot`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
export interface SteamPreferences {
  wins: boolean; matches: boolean; practice: boolean; scrims: boolean;
  weekly: boolean; broadcasts: boolean; leadMinutes: number; teamIds: string[]; teamSelection: 'selected' | 'all';
  timeZone: string; quietEnabled: boolean; quietStart: number; quietEnd: number;
}
export interface SteamBotStatus {
  available: boolean; online: boolean; botProfile: string | null;
  subscription: { enabled: boolean; friendState: string; steamId64: string } | null;
  preferences: SteamPreferences; teams: { id: string; name: string }[];
}
export interface SteamBotAdminStatus {
  available: boolean; online: boolean; subscribers: number; recipients: number;
  runtime: { state: string; friendCount: number; heartbeatAt: string } | null;
  queue: { status: string; _count: number }[];
}
export interface SteamBotAdminUser {
  userId: string; name: string; avatarUrl: string | null; steamId64: string; enabled: boolean;
  friendState: string; connectedAt: string | null; enabledAt: string; canSend: boolean;
  preferences: SteamPreferences; counts: Record<string, number>; lastSentAt: string | null;
}
export interface SteamBotAdminUsers { historyDays: number; users: SteamBotAdminUser[] }
export const steamBotService = {
  status: async () => (await axios.get<SteamBotStatus>(API, auth())).data,
  connect: async () => (await axios.post<SteamBotStatus>(`${API}/connect`, {}, auth())).data,
  save: async (prefs: SteamPreferences) => (await axios.put<SteamBotStatus>(`${API}/preferences`, prefs, auth())).data,
  disconnect: async () => (await axios.delete<SteamBotStatus>(`${API}/connection`, auth())).data,
  admin: async () => (await axios.get<SteamBotAdminStatus>(`${API}/admin/status`, auth())).data,
  users: async () => (await axios.get<SteamBotAdminUsers>(`${API}/admin/users`, auth())).data,
  broadcast: async (title: string, body: string, requestId: string, userId?: string) => (await axios.post<{ queued: number }>(`${API}/admin/broadcast`, { title, body, requestId, userId }, auth())).data,
};
export function steamBotError(error: unknown): string {
  return axios.isAxiosError(error) && typeof error.response?.data?.message === 'string'
    ? error.response.data.message : 'Could not reach Steam reminders. Please try again.';
}
